import {axiosService} from "../axios";

export const chatService = {

    uploadFile: (file) => {

        const formData = new FormData();
        formData.append('file', file);

        return axiosService.post("/api/chats/upload", formData);

    },

    deleteChat: (id) => {
        return axiosService.delete(`/api/chats/${id}`);
    },

    ask: (chatId, question) => {
        return axiosService.post(`/api/chats/${chatId}/ask`, {question: question});
    },

    getChats: () => {
        return axiosService.get("/api/chats");
    },

    getChatsUsingFile: (fileId) => {
        return axiosService.get(`/api/chats/files/${fileId}`);
    },

    useFile: (fileId) => {

        return axiosService.post(`/api/chats/use-file/${fileId}`, {fileId});

    },

    fetchPreview: (id) => {
        return axiosService.get(`/api/chats/${id}/preview`);
    },

    fetchData(chatId, tableName, page, size, filter, sort) {
        const sortPart = sort !== undefined ? `&sort=${sort}` : '';
        return axiosService.post(`/api/chats/${chatId}/data/${tableName}?page=${page - 1}&size=${size}${sortPart}`, {filter: filter})
    },

    downloadData(chatId, tableName, filter, sort, format) {
        const sortPart = sort !== undefined ? `&sort=${sort}` : '';
        return axiosService.post(`/api/chats/${chatId}/data/${tableName}/download?${sortPart}`, {filter: filter, format: format}, {
            responseType: "blob"
        })
    },

    convertToJson: (data) => {
        try {
            return JSON.parse(data);
        } catch (e) {
            return data;
        }

    }

};
